import { TerminalCashTransferStates, TransferMechanism } from '@Types'

export const WITHDRAWAL = 'Withdrawal'
export const DEPOSIT = 'Deposit'
export const TRANSFER_DETAILS = 'transferDetails'
export const CHECK_DETAILS = 'checkDetails'
export const IRA_CONTRIBUTION = 'iraContribution'
export const IRA_DISTRIBUTION = 'iraDistribution'
export const STATE = 'state'
export const FEDERAL = 'federal'
export const WITHHOLDING_TYPE = 'WithholdingType'
export const WITHHOLDING_AMOUNT = 'WithholdingAmount'
export const PREVIOUS = 'previous'
export const CURRENT = 'current'

export const ALLOWED_CANCEL_STATES = new Set([
  TerminalCashTransferStates.ReviewPending,
  TerminalCashTransferStates.Postponed,
  TerminalCashTransferStates.Approved,
  TerminalCashTransferStates.FundsPosted
])

export enum TerminalPositionJournalStates {
  PositionPosted = 'PositionPosted',
  ReviewPending = 'ReviewPending',
  Postponed = 'Postponed',
  Approved = 'Approved'
}

export const ALLOWED_POSITION_CANCEL_STATES = new Set([
  TerminalPositionJournalStates.PositionPosted,
  TerminalPositionJournalStates.ReviewPending,
  TerminalPositionJournalStates.Postponed,
  TerminalPositionJournalStates.Approved
])

export const ALLOWED_CANCEL_METHODS = new Set([
  TransferMechanism.Ach,
  TransferMechanism.Journal,
  TransferMechanism.Check,
  TransferMechanism.Rtp
])
